import { useLazyQuery, useQuery } from '@apollo/client';
import pdca_t_pdcaQueries from '../../queries/pdca_t_pdca.queries';
import { FETCH_T_PDCAS } from '../../queries/pdca_t_pdca.queries.type';
import { useCallback, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { FETCH_M_LG_CONFIG } from '@/main/queries/setting_m_lg_config.queries.type';
import setting_m_lg_configQueries from '@/main/queries/setting_m_lg_config.queries';

type UseJigyoListContainer = () => {
    data: FETCH_T_PDCAS | undefined;
    lgConfigData: FETCH_M_LG_CONFIG | undefined;
    onNavigate: (jigyoID: string) => void;
    urlParams: { lgcode: string; jigyoYear: string };
};

/**
 * 事業一覧ページのContainerカスタムフック
 * @returns
 */
export const useJigyoListContainer: UseJigyoListContainer = () => {
    const { lgcode, jigyoYear }: { lgcode: string; jigyoYear: string } = useParams();
    const history = useHistory();

    const { data: lgConfigData } = useQuery<FETCH_M_LG_CONFIG>(setting_m_lg_configQueries.FETCH_M_LG_CONFIG, {
        variables: { lgcode },
        fetchPolicy: 'cache-first',
    });

    // 事業データ取得の準備
    const [loadJigyoData, { data }] = useLazyQuery<FETCH_T_PDCAS>(pdca_t_pdcaQueries.FETCH_T_PDCAS, {
        // variables: { lgcode, createdYear: Number(jigyoYear) + 1, jigyoYear: Number(jigyoYear), processCd: 10 },
        onError: (error) => console.error(error.message),
        fetchPolicy: 'cache-first',
    });

    // lgConfigDataが取得できたらjigyoDataを取得
    useEffect(() => {
        if (lgConfigData?.setting_m_lg_config[0]?.created_year) {
            const processCd = lgConfigData.setting_m_lg_config[0]?.created_year === Number(jigyoYear) || Number(jigyoYear) + 1 ? 30 : 10;
            const createdYear = processCd === 30 ? Number(jigyoYear) - 1 : lgConfigData.setting_m_lg_config[0]?.created_year;

            loadJigyoData({
                variables: {
                    lgcode,
                    createdYear: createdYear,
                    jigyoYear: Number(jigyoYear),
                    jigyoYearPrev: Number(jigyoYear) - 1,
                    processCd: processCd,
                },
            });
        }
    }, [lgConfigData, lgcode, jigyoYear]);

    // // 事業一覧データ取得
    // const { data } = useQuery<FETCH_T_PDCAS>(pdca_t_pdcaQueries.FETCH_T_PDCAS, {
    //     variables: { lgcode, createdYear: Number(jigyoYear) + 1, jigyoYear: Number(jigyoYear), processCd: 10 },
    //     onError: (error) => console.error(error.message),
    //     fetchPolicy: 'cache-first',
    // });

    /**
     * 画面推移
     * @param jigyoID
     */
    const onNavigate = useCallback(
        (jigyoID: string) => {
            history.push({
                pathname: `/jigyodetail/${lgcode}/${jigyoYear}/${jigyoID}`,
                state: {
                    // master_list: master_list,
                    // id_list: id_list,
                    // menucd: menucd,
                },
            });
        },
        [history, lgcode, jigyoYear]
    );
    return { data, onNavigate, lgConfigData, urlParams: { lgcode, jigyoYear } };
};
